import { Components, Theme } from "@mui/material/styles";

export const MuiTableCell = (theme: Theme) =>
  ({
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: theme.palette.tables.tableCell.borderBottom,
        },
      },
    },
  }) satisfies Components<Theme>;
